import React from 'react';
import useReAuthorizationChecker, {
  RE_AUTHORIZATION_REASONS
} from 'components/hooks/useReAuthorizationChecker';
import { IDENTITY_PROVIDERS } from 'common/constants/constants';
import useToggle from 'components/hooks/useToggle';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
const withSlackReAuthorization = WrappedComponent => props => {
  const { sensorAuthorization, account, teamOnSlack = true } = props;
  const localStorageAccessor = BrowserStorageAccessor().local;

  const reAuthorizationStatus = useReAuthorizationChecker(
    IDENTITY_PROVIDERS.SLACK,
    sensorAuthorization
  );

  const enableReAuthorizationButton =
    reAuthorizationStatus.needReAuthorization &&
    ((sensorAuthorization && account.id === sensorAuthorization.account_id) ||
      account.type_id === ACCOUNT_TYPES_MAP.Primary);

  const slackMissingScopes = reAuthorizationStatus.reasons.includes(
    RE_AUTHORIZATION_REASONS.MISSING_SCOPES
  );

  const slackInvalidToken = reAuthorizationStatus.reasons.includes(
    RE_AUTHORIZATION_REASONS.INVALID_TOKEN
  );

  const slackReAuthorizationDissmissed =
    sensorAuthorization &&
    localStorageAccessor.get(
      `${sensorAuthorization.account_id}-${(
        sensorAuthorization.scopes || []
      ).join('-')}`
    );

  const [isDismissed, dismiss] = useToggle(slackReAuthorizationDissmissed);

  const showSlackReAuthorizationDialog =
    enableReAuthorizationButton &&
    slackMissingScopes &&
    teamOnSlack &&
    !isDismissed;

  return (
    <WrappedComponent
      showSlackReAuthorizationDialog={showSlackReAuthorizationDialog}
      dismissSlackReAuthorizationDialog={dismiss}
      enableReAuthorizationButton={enableReAuthorizationButton}
      slackMissingScopes={slackMissingScopes}
      slackInvalidToken={slackInvalidToken}
      {...props}
    />
  );
};

export default withSlackReAuthorization;
